module.exports = __webpack_public_path__ + "static/media/Muehle.628c938b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Muehle.jpg
// module id = 763
// module chunks = 0